/**
 * @file Automatically generated by barrelsby.
 */

export * from './aggregate.component';
